import * as firebase from 'firebase/app';
import { getAuth } from "firebase/auth";
import { firebaseConfig } from './settings';
import { getFirestore } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';
export const app = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);
